export const FindAromaFruitFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，看來你想要多瞭解關於咖啡的果香對吧～"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["你想要知道哪些知識呢？"],
      choices: [
        { label: "果香指的那些味道？", value: 1 },
        { label: "為什麼咖啡會有果香？", value: 2 }
      ],
      afterAnswer: async resp => {
        if (resp.value === 0) {
          return {
            message:
              "在咖啡的風味輪中，我們又稱之為水果韻，一般可以品嚐到種類有柑橘、桔子、檸檬、橘子、蘋果、葡萄、鳳梨等不同的味道。"
          };
        } else {
          return {
            message:
              "絕大多數市面上精品咖啡豆都是種植在高海拔地區的阿拉比卡豆，因為它處於海拔較高地區的關係，生長速度較緩慢，能夠發展出風味健全的豆子，一般而言，阿拉比卡豆的味道較甜、柔和並富有果香，並受到咖啡人的喜愛。\r\n精品咖啡豆的特色，除了受到海拔高低影響風味外，連土壤、季風、氣候變遷等都會使之產生口味變化，因此每個生產咖啡豆的國家、莊園的風味都有所不同，可先以世界地圖來找喜愛的豆子風味，若有興趣再深入研究該國不同莊園生產的豆子，這樣會更有效率的找到適合自己的咖啡。"
          };
        }
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["要不要試試大咖推薦一些富有果香的咖啡豆給您試試呢？"],
      choices: [
        { label: "我想嘗試！", value: 1 },
        { label: "不管是哪種果香都給我來一點", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的！這邊為您推薦有果香的產品。希望你會喜歡喔！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/果香", label: "果香" }]
    }
  ]
];

export const FindAromaLandFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，土地芬芳聽起來是個很神奇的味道~"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["我猜你可能會想多了解一下對吧？"],
      choices: [
        { label: "土地芬芳是什麼？", value: 1 },
        { label: "跟產地有關係嗎？", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            '英文“Earthy" 代表的是咖啡根據產地跟莊園處理法過程當中，與土地的地氣相融，讓咖啡的風味也混合到了在地土壤或土質的特性，在特定產區的豆子，這些風味也代表了其獨特性。'
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["要試試看有地域之味的咖啡豆嗎？"],
      choices: [
        { label: "聽起來很玄，來試試！", value: 1 },
        { label: "想感受看看", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message: "好的！這邊為您推薦有土地芬芳味的咖啡產品。可以探索看看！"
        };
      },
      extra: {
        type: "single-select"
      },
      results: [
        { answer: "*-*-*", url: "/products/土地芬芳", label: "土地芬芳" }
      ]
    }
  ]
];

export const FindAromaSmokedFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，是不是很難想像咖啡會有煙熏味~"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我來跟你說明一下好嗎？"],
      choices: [
        { label: "好啊!", value: 1 },
        { label: "什麼是煙燻味啊？", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "煙熏味的來源大致上有來自兩種情況，一個是咖啡豆的產地就造就了本身的煙感，這個風味大多較不明顯。\r\n另一種較常發生的情況是在豆子烘焙的過程當中，溫度跟時間的因素，所謂的控火，這是基本功，不能讓溫度跑的過快，升溫過快，而造成煙感。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["要試試看有煙薰感的咖啡豆嗎？"],
      choices: [
        { label: "滿有趣的喔，想品嚐！", value: 1 },
        { label: "我來試試看", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的！帶有一點煙熏風味的咖啡產品。試試看吧！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/煙熏", label: "煙熏" }]
    }
  ]
];

export const FindAromaFlowerFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，花香味是大家很常提到一種咖啡氣味喔~"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我來跟你介紹一下"],
      choices: [
        { label: "好啊!", value: 1 },
        { label: "我想了解更多", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "香氣主要來自於「酵素作用」，表現出的香氣有; 咖啡花、茉莉花、茶玫瑰、薰衣草、百香果。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["來試試看花香味的咖啡豆嗎？"],
      choices: [
        { label: "讓我來瞧瞧!", value: 1 },
        { label: "當然好喔～", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，帶有花香的咖啡產品最受歡迎！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/花香", label: "花香" }]
    }
  ]
];

export const FindAromaBerryFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，莓果味通常讓咖啡酸度上會有呈現不同的風貌~"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["有興趣多了解嗎？"],
      choices: [
        { label: "當然好囉！!", value: 1 },
        { label: "沒問題～", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "淺中焙咖啡豆較能體現出產地的酸度跟甜度這兩者的變化，會表現出不同的莓果氣味如烏梅、藍莓、草莓、黑醋栗、櫻桃、杏桃。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["試試看莓果香氣的咖啡豆嗎？"],
      choices: [
        { label: "好，迫不及待了！", value: 1 },
        { label: "當然好喔～", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，帶有莓果香的咖啡產品，你也來試試！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/莓果", label: "莓果" }]
    }
  ]
];

export const FindAromaNutFlow = [
  [
    {
      type: "comment",
      hint: ["哈囉，我是大咖，堅果味聽起來就很可口吧？"]
    },
    {
      type: "select",
      hint: ["我們致力於推最適合你的咖啡,讓我們一起來試試吧!"],
      choices: [
        { label: "來!", value: 1 },
        { label: "來都來!", value: 2 },
        { label: "來吧來吧!", value: 2 }
      ],
      afterAnswer: async value => {
        let message = "就知道你一定很想喝大咖為你挑的咖啡~~~";
        return {
          message
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["讓我來跟你說明堅果味代表的內容吧"],
      choices: [
        { label: "我想聽聽看!", value: 1 },
        { label: "好優好優～", value: 2 }
      ],
      afterAnswer: async resp => {
        return {
          message:
            "香氣主要來自於「糖褐變反映」，表現出的香氣在中深焙的狀態較容易散發出堅果味，主要是核果類的杏仁、玉米、胡桃，有時也會伴隨焦糖以及巧克力的味覺。"
        };
      },
      extra: {
        type: "single-select"
      }
    },
    {
      type: "select",
      hint: ["試試看堅果味的咖啡豆嗎？"],
      choices: [
        { label: "感覺味道很香！", value: 1 },
        { label: "當然好喔～", value: 2 }
      ],
      afterAnswer: async resp => {
        return { message: "好的，帶有堅果味的咖啡產品，推薦給你！" };
      },
      extra: {
        type: "single-select"
      },
      results: [{ answer: "*-*-*", url: "/products/堅果", label: "堅果" }]
    }
  ]
];
